const ACCESS_KEY = "clinic_access_token";
const REFRESH_KEY = "clinic_refresh_token";

export function getAccessToken() {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefreshToken() {
  return localStorage.getItem(REFRESH_KEY);
}

export function setTokens(access, refresh) {
  if (access) localStorage.setItem(ACCESS_KEY, access);
  // ROTATE_REFRESH_TOKENS=True means every refresh call returns a NEW
  // refresh token and blacklists the old one — always overwrite, never
  // keep reusing an old refresh token once a new one has been issued.
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}
